import React from "react";
import { ErrorText } from "..";

export const TextAreaInput = ({
    name,
    className,
    value,
    onBlur,
    onChange,
    disabled,
    placeholder,
    mainWrapCls,
    isError,
    errorText,
}) => (
    <div>
        <div className={mainWrapCls}>
            <textarea
                value={value}
                onChange={onChange}
                className={isError ? 'errorField' : className}
                onBlur={onBlur}
                maxLength={280}
                name={name}
                disabled={disabled}
                placeholder={placeholder}
            />
        </div>
        {isError && (
            <div>
                <ErrorText text={errorText} />
            </div>
        )}
    </div>
);

TextAreaInput.defaultProps = {
    mainWrapCls: "loginInputWrap",
    className: "loginInput",
    disabled: false
};
